import { map } from 'lodash'
import { useCallback, useMemo } from 'react'
import { graphql, useFragment, useMutation } from 'react-relay'

import {
  type useGenderCriteria_query$data,
  type useGenderCriteria_query$key
} from '@/__generated__/useGenderCriteria_query.graphql'
import { type useGenderCriteriaMutation } from '@/__generated__/useGenderCriteriaMutation.graphql'

type CommitAsyncFn = (genderIds: string[]) => Promise<useGenderCriteria_query$data>

export const useGenderCriteria = (
  queryRef?: useGenderCriteria_query$key | null | undefined
): [string[], CommitAsyncFn, boolean] => {
  const queryData = useFragment(
    graphql`
      fragment useGenderCriteria_query on Query {
        currentUser {
          genderCriteria(orderBy: [GENDER_BY_GENDER_ID__SEQUENCE_ASC]) {
            nodes {
              genderId
            }
          }
        }
      }
    `,
    queryRef
  )
  const data = useMemo(
    () => map(queryData?.currentUser?.genderCriteria.nodes, 'genderId'),
    [queryData?.currentUser?.genderCriteria.nodes]
  )
  const [commit, isPending] = useMutation<useGenderCriteriaMutation>(graphql`
    mutation useGenderCriteriaMutation($input: UpdateGenderCriteriaInput!) {
      updateGenderCriteria(input: $input) {
        query {
          ...useGenderCriteria_query
        }
      }
    }
  `)

  const commitAsync = useCallback<CommitAsyncFn>(
    (genderIds: string[]) =>
      new Promise((resolve, reject) =>
        commit({
          onCompleted: (response, errors) => {
            if (errors) {
              reject(errors)
            } else {
              // @ts-ignore false negative
              resolve(response)
            }
          },
          variables: {
            input: {
              genderIds
            }
          }
        })
      ),
    [commit]
  )

  return [data, commitAsync, isPending]
}
